import { create } from "zustand";
import { enableMapSet } from "immer";
import { immer } from "zustand/middleware/immer";

enableMapSet();

const useThreadStore = create(
  immer((set, get) => ({
    allCategories: [],
    category: null,
    categoryRefreshToken: 0,
    isCategoryLoading: false,
    catError: false,
    threads: [],
    cursor: null,
    hasMore: true,
    selectedThreadIds: new Set(),
    scrollPositions: {},

    setAllCategories: (categories) => set({ allCategories: categories }),

    setCategory: (cat) => set({ category: cat }),

    setThreads: (threads, cursor, hasMore) =>
      set((state) => {
        state.threads = threads;
        state.cursor = cursor;
        state.hasMore = hasMore;
      }),
    setThreadsOnError: (threads, hasMore) =>
      set((state) => {
        state.threads = threads;
        state.hasMore = hasMore;
      }),

    addThreads: (threads, cursor, hasMore) =>
      set((state) => {
        state.threads.push(...threads);
        state.cursor = cursor;
        state.hasMore = hasMore;
      }),

    resetThreads: () =>
      set((state) => {
        state.threads = [];
        state.cursor = null;
        state.hasMore = true;
        state.selectedThreadIds.clear();
      }),

    // toggleThreadSelection: (threadId) =>
    //   set((state) => {
    //     if (state.selectedThreadIds.has(threadId)) {
    //       state.selectedThreadIds.delete(threadId);
    //     } else {
    //       state.selectedThreadIds.add(threadId);
    //     }
    //   }),

    // selectAllThreadsOnPage: (threadIds) =>
    //   set((state) => {
    //     threadIds.forEach((id) => state.selectedThreadIds.add(id));
    //   }),

    // deselectAllThreads: () =>
    //   set((state) => {
    //     state.selectedThreadIds.clear();
    //   }),

    getSelectedThreads: () => Array.from(get().selectedThreadIds),

    setSelectedThreads: (updater) =>
      set((state) => {
        const updated =
          typeof updater === 'function'
            ? updater(state.selectedThreadIds)
            : updater;
        return { selectedThreadIds: updated };
      }),

    saveScrollPosition: (categoryName, scrollY) =>
      set((state) => {
        state.scrollPositions[categoryName] = scrollY;
      }),

    getScrollPosition: (categoryName) => get().scrollPositions[categoryName],

    removeThreadsById: (threadIds) =>
      set((state) => {
        state.threads = state.threads.filter(
          (t) => !threadIds.includes(t.thread_id)
        );
        threadIds.forEach((id) => state.selectedThreadIds.delete(id));
      }),
    removeCommissionsById: (commission_ids) =>
      set((state) => {
        state.threads = state.threads.filter(
          (t) => !commission_ids.includes(t.commission_id)
        );
      }),
    removeClientNotesById: (ids) =>
      set((state) => {
        state.threads = state.threads.filter(
          (t) => !ids.includes(t.id)
        );
    }),
    decrementCategoryCount: (categoryName, count = 1) =>
      set((state) => {
        const cat = state.allCategories.find((c) => c.name === categoryName);
        if (cat) cat.count = Math.max(0, (cat.count ?? 0) - count);
        if (state.category?.name === categoryName) {
          state.category.count = Math.max(0, (state.category.count ?? 0) - count);
        }
      }),

    refreshCategoryList: async (axiosInstance) => {
      set({
        catError: false,
        isCategoryLoading: true
      });
      try {
        const res = await axiosInstance.get(`/categories/list`);
        set({
          allCategories: res.data.data || [],
          categoryRefreshToken: get().categoryRefreshToken + 1
        });
      } catch (err) {
        set({
          catError: true,
        });
        console.error("Failed to refresh category list", err);
      }
      finally {
        set({
          catError: false,
          isCategoryLoading: false
        });
      }
    },
  }))
);

export default useThreadStore;
